import { render, staticRenderFns } from "./ViewHits.vue?vue&type=template&id=48a258d4&scoped=true&"
import script from "./ViewHits.vue?vue&type=script&lang=js&"
export * from "./ViewHits.vue?vue&type=script&lang=js&"
import style0 from "./ViewHits.vue?vue&type=style&index=0&id=48a258d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a258d4",
  null
  
)

export default component.exports